import { chatwoot, kanbanApi } from './chatwoot'
import type { ChatwootMessage, Conversation } from '@/types/chatwoot'

export interface ConversationsMeta {
  mine_count: number
  assigned_count: number
  unassigned_count: number
  all_count: number
}

interface ConversationsResponse {
  data: {
    meta: ConversationsMeta
    payload: Conversation[]
  }
}

export interface FetchPageResult {
  conversations: Conversation[]
  meta: ConversationsMeta
}

export interface FetchPageParams {
  page: number
  status?: 'open' | 'resolved' | 'pending' | 'snoozed'
  assigneeType?: 'me' | 'unassigned' | 'assigned' | 'all'
}

export async function fetchConversationsPage(
  params: FetchPageParams,
): Promise<FetchPageResult> {
  const { data } = await chatwoot.get<ConversationsResponse>('/conversations', {
    params: {
      page: params.page,
      status: params.status ?? 'open',
      assignee_type: params.assigneeType ?? 'all',
    },
  })
  return {
    conversations: data.data.payload,
    meta: data.data.meta,
  }
}

export async function fetchConversation(id: number): Promise<Conversation> {
  const { data } = await chatwoot.get<Conversation>(`/conversations/${id}`)
  return data
}

// Atalho de bootstrap: traz TODAS as conversas open em 1 request ao
// kanban-api (que faz SQL direto no Postgres do Chatwoot). Substitui
// as 61 paginas REST do load() anterior. Se falhar, o store cai
// automaticamente para `fetchConversationsPage` em loop.
export async function fetchAllConversationsBoot(): Promise<FetchPageResult> {
  const { data } = await kanbanApi.get<ConversationsResponse>('/conversations')
  return {
    conversations: data.data.payload,
    meta: data.data.meta,
  }
}

interface MessagesResponse {
  payload: ChatwootMessage[]
}

export async function fetchMessages(
  conversationId: number,
  perPage = 5,
): Promise<ChatwootMessage[]> {
  const { data } = await chatwoot.get<MessagesResponse>(
    `/conversations/${conversationId}/messages`,
    { params: { per_page: perPage } },
  )
  return data.payload
}

// Envia mensagem (ou nota privada) numa conversation. `message_type: 'outgoing'`
// é uma resposta do agente; `private: true` torna a mensagem visível só pro
// time do Chatwoot (não vai pro cliente no inbox).
export async function sendMessage(
  conversationId: number,
  content: string,
  isPrivate = false,
): Promise<ChatwootMessage> {
  const { data } = await chatwoot.post<ChatwootMessage>(
    `/conversations/${conversationId}/messages`,
    {
      content,
      message_type: 'outgoing',
      private: isPrivate,
    },
  )
  return data
}
